// extracted by mini-css-extract-plugin
module.exports = {"formSpace":"style_formSpace__scY1G","loading":"style_loading__DsPsj","skeletonWrapper":"style_skeletonWrapper__Zz4EQ"};